module.exports = __webpack_public_path__ + "static/media/Primary_Landscape_Full.e790c045.svg";